import {load} from '@shopify/theme-sections';
import 'preact/devtools';
import {Fancybox} from '@fancyapps/ui';

// TEMPLATES
import './templates/collection.js';
import './templates/product.js';
import './templates/search.js';
import './templates/404.js';
import './templates/page.swym.js';

// SECTIONS
import './sections/business-reviews.js';
import './sections/featured-collections.js';
import './sections/featured-reviews.js';
import './sections/header.js';
import './sections/hero-slider.js';
import './sections/image-text-cta.js';
import './sections/product-gallery.js';
import './sections/recommended-collection.js';
import './sections/spend-and-win.js';
import './sections/shop-by-category.js';
import './sections/trending-categories.js';
import './sections/trust.js';

// COMPONENTS
import initProductCards from './components/product-card';
import pdpSizeGuide from './components/pdp-size-guide';
import productOptions from './components/product-options';
import initDeliveryTimer from './components/delivery-timer';
import modelSelector from './components/model-selector.js';
import initCountdownTimer from './components/countdown-timer.js';

// REACT APPS
import '../app';

// Make Fancybox globally available
window.Fancybox = Fancybox;

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  // Initialize Fancybox
  Fancybox.bind('[data-fancybox]', {
    // Global Fancybox options
  });

  initProductCards();
  initCountdownTimer();
  modelSelector();
  pdpSizeGuide();
  productOptions();
  initDeliveryTimer();
});
